import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/jugend-zaehlt/logo.png")